import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Typography,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import OverlaySpinner from 'components/spinners/OverlaySpinner';

const useStyles = makeStyles((theme) => ({
  noMarginBottom: {
    marginBottom: 0,
  },
  lastButton: {
    marginRight: 0,
    marginBottom: 0,
  },
  dialogContentHeight: {
    height: '15rem',
  },
  dialogContentAuto: {
    height: 'auto',
  },
  error: {
    color: theme.palette.error.main,
    textAlign: 'right',
    fontSize: '0.8rem',
  },
}));

type DialogProps = {
  title: string;
  isOpen?: boolean;
  isLoading?: boolean;
  editMode?: boolean;
  canSubmit?: boolean;
  error?: string;
  onSubmit?: () => void;
  onClose?: () => void;
  children?: React.ReactNode;
};

const CreateEditDialog: React.FC<DialogProps> = ({
  title,
  isOpen,
  isLoading,
  editMode,
  canSubmit,
  error,
  onClose,
  onSubmit,
  children,
}) => {
  const classes = useStyles();
  const { t } = useTranslation(['translations']);

  const handleClose = () => {
    if (!isLoading) {
      onClose && onClose();
    }
  };

  return (
    <Dialog
      disableBackdropClick={false}
      disableEscapeKeyDown={false}
      maxWidth="md"
      open={isOpen === true}
      onClose={handleClose}
    >
      <OverlaySpinner isLoading={isLoading}>
        <DialogTitle disableTypography={true}>
          <Typography variant="h3">{title}</Typography>
        </DialogTitle>

        <DialogContent
          className={
            editMode ? classes.dialogContentAuto : classes.dialogContentHeight
          }
        >
          {children}
        </DialogContent>
        <Typography className={classes.error}>{error}</Typography>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            className={classes.noMarginBottom}
          >
            {t('common.cancel')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={!canSubmit}
            className={classes.lastButton}
          >
            {editMode ? t('common.save') : t('common.create')}
          </Button>
        </DialogActions>
      </OverlaySpinner>
    </Dialog>
  );
};

export { CreateEditDialog };
